export const initialState = {
  currentJobStatus: null,
  newBioIsVisible: false,
  currentBio: '',
  newExperieceIsVisible: false,
  currentExperiece: null,
  newEducationIsVisible: false,
  currentEducation: null,
  newSkillIsVisible: false,
  currentSkill: null,
  newAchievementIsVisible: false,
  currentAchievement: null,
  newContactInfoVisible: false,
  currentContactInfo: null,
  editProjectsIsVisible: false,
  currentProjects: [],
  editLinksIsVisible: false,
  currentLinks: [],
};

export const types = {
  SET_CURRENT_JOB_STATUS: 'SET_CURRENT_JOB_STATUS',
  SET_NEW_BIO_IS_VISIBLE: 'SET_NEW_BIO_IS_VISIBLE',
  SET_CURRENT_BIO: 'SET_CURRENT_BIO',
  SET_NEW_EXPERIENCE_IS_VISIBLE: 'SET_NEW_EXPERIENCE_IS_VISIBLE',
  SET_CURRENT_EXPERIENCE: 'SET_CURRENT_EXPERIENCE',
  SET_NEW_EDUCATION_IS_VISIBLE: 'SET_NEW_EDUCATION_IS_VISIBLE',
  SET_CURRENT_EDUCATION: 'SET_CURRENT_EDUCATION',
  SET_NEW_SKILL_IS_VISIBLE: 'SET_NEW_SKILL_IS_VISIBLE',
  SET_CURRENT_SKILL: 'SET_CURRENT_SKILL',
  SET_NEW_ACHIEVEMENT_IS_VISIBLE: 'SET_NEW_ACHIEVEMENT_IS_VISIBLE',
  SET_CURRENT_ACHIEVEMENT: 'SET_CURRENT_ACHIEVEMENT',
  SET_NEW_CONTACT_INFO_IS_VISIBLE: 'SET_NEW_CONTACT_INFO_IS_VISIBLE',
  SET_CURRENT_CONTACT_INFO: 'SET_CURRENT_CONTACT_INFO',
  SET_EDIT_PROJECTS_IS_VISIBLE: 'SET_EDIT_PROJECTS_IS_VISIBLE',
  SET_CURRENT_PROJECTS: 'SET_CURRENT_PROJECTS',
  SET_EDIT_LINKS_IS_VISIBLE: 'SET_EDIT_LINKS_IS_VISIBLE',
  SET_CURRENT_LINKS: 'SET_CURRENT_LINKS',
  SET_MULTI: 'SET_MULTI',
};

export const reducer = (state, { type, payload }) => {
  switch (type) {
    case types.SET_CURRENT_JOB_STATUS:
      return { ...state, currentJobStatus: payload };
    case types.SET_NEW_BIO_IS_VISIBLE:
      return { ...state, newBioIsVisible: payload };
    case types.SET_CURRENT_BIO:
      return { ...state, currentBio: payload };
    case types.SET_NEW_EXPERIENCE_IS_VISIBLE:
      return { ...state, newExperieceIsVisible: payload };
    case types.SET_CURRENT_EXPERIENCE:
      return { ...state, currentExperiece: payload };
    case types.SET_NEW_EDUCATION_IS_VISIBLE:
      return { ...state, newEducationIsVisible: payload };
    case types.SET_CURRENT_EDUCATION:
      return { ...state, currentEducation: payload };
    case types.SET_NEW_SKILL_IS_VISIBLE:
      return { ...state, newSkillIsVisible: payload };
    case types.SET_CURRENT_SKILL:
      return { ...state, currentSkill: payload };
    case types.SET_NEW_ACHIEVEMENT_IS_VISIBLE:
      return { ...state, newAchievementIsVisible: payload };
    case types.SET_CURRENT_ACHIEVEMENT:
      return { ...state, currentAchievement: payload };
    case types.SET_NEW_CONTACT_INFO_IS_VISIBLE:
      return { ...state, newContactInfoVisible: payload };
    case types.SET_CURRENT_CONTACT_INFO:
      return { ...state, currentContactInfo: payload };
    case types.SET_EDIT_PROJECTS_IS_VISIBLE:
      return { ...state, editProjectsIsVisible: payload };
    case types.SET_CURRENT_PROJECTS:
      return { ...state, currentProjects: payload };
    case types.SET_EDIT_LINKS_IS_VISIBLE:
      return { ...state, editLinksIsVisible: payload };
    case types.SET_CURRENT_LINKS:
      return { ...state, currentLinks: payload };
    case types.SET_MULTI:
      return { ...state, ...payload };
    default:
      throw new Error();
  }
};
